import CommonDAO from '../storage/CommonDAO'

const getLoggedUserId = (): string => {
  const userId = CommonDAO.getLoggedInUserId();
  if (!userId) {
    throw new Error('No logged user ID found in storage.');
  }
  return userId;
};

const getUserScopedStorageKeys = () => {
  const userId = getLoggedUserId();

  return {
    DEVICE_ID_KEY: `@stockeasy:${userId}:deviceId`,
    SCAN_SESSION_HEADER_COLLECTION_KEY: `@stockeasy:${userId}:scanSessionHeaderCollection`,
    SCAN_SESSION_RECORD_PREFIX: `@stockeasy:${userId}:scanSession_`,
    TRIGGER_BUTTON_POSITION_KEY: `@stockeasy:${userId}:triggerButtonPosition`,
    USER_KEY: `@stockeasy:${userId}:user`,
    AUTH_KEY: `@stockeasy:${userId}:auth`,
    REMEMBER_ME_KEY: `@stockeasy:${userId}:rememberMe`,
  };
};

export { getUserScopedStorageKeys };
